import { render } from "./circle.vue?vue&type=template&id=04cde8ca&scoped=true"
import script from "./circle.vue?vue&type=script&lang=js"
export * from "./circle.vue?vue&type=script&lang=js"

import "./circle.vue?vue&type=style&index=0&id=04cde8ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cde8ca"]])

export default __exports__